import React, {
  useState,
  useRef,
  useMemo,
  useEffect,
  useCallback,
} from 'react';
import { Form } from '@unform/web';

import { Modal, ModalBody, ModalFooter, Row, Col } from 'reactstrap';

import * as Yup from 'yup';

import { toast } from 'react-hot-toast';
import {
  AiOutlinePrinter,
  AiOutlineCheckCircle,
  AiOutlineCloseCircle,
} from 'react-icons/ai';
import {
  FaRedo,
  FaExclamationCircle,
  FaPrint,
  FaCashRegister,
  FaEye,
} from 'react-icons/fa';
import { BiTransfer } from 'react-icons/bi';

import ReactToPrint from 'react-to-print';

import { TiTicket } from 'react-icons/ti';
import { useAuth } from '~/context/AuthContext';
import SelectTable from '~/components/Form/SelectTable';
import FooterNF from '~/components/FooterNF';
import PaymentForm from '~/components/PaymentForm';
import formatCompleteDate from '~/services/formatCompleteDate';
import api from '~/services/api';

import getValidationErrors from '~/services/getValidationErrors';
import { useClube } from '~/context/ClubeContext';
import { Button, OrderButton, PaymentPercentTag } from 'ui-kit-takeat';
import formatValue from '~/utils/formatValue';
import { fetchDataToPrint } from '~/services/printer/dataToPrint';
import { printHtmlInIframe } from '~/services/printer/printerUtils';
import {
  Modal as ModalKit,
  Input as InputStyled,
  Button as ButtonKit,
} from 'takeat-design-system-ui-kit';
import { ModalConfirmation } from '../ModalConfirmation';
import Input from '../Form/Input';
import PrintBillsOrderOperation from '../Prints/PrintBillsOrderOperation';
import EyeOrdersBillOperation from '../Tables/EyeOrdersBillOperation';
import OrdersBillOperation from '../Tables/Bills/OrdersBillOperation';
import EyeBillsTableOperation from '../Tables/CloseOrder/Eye/EyeBillsTableOperation';
import {
  Actions,
  ModalPaymentBody,
  DisplayNoneImprimir,
  ActionsInside,
  DeleteAndEditActions,
  CloseButton,
  ButtonStyled,
  CardContainer,
  CardTop,
  CardBottom,
  InnerArea,
} from './styles';

export default function BillOperation({
  session,
  getSessions,
  setSessions,
  sessions,
  inicialDate,
  finalDate,
  has_nfce,
  getTablesAvailable,
  orderByTableDate,
  getMinimalSessions,
  setAllTablesAvailable,
  setInputValueTables,
  setTablesFilteredSearch,
}) {
  const { user } = useAuth();
  const { sessionsAwarded, handlePontuarSession, loadingPontuarSession } =
    useClube();
  const [sessionToUse, setSessionToUse] = useState(session);
  const [, setTableChanged] = useState(null);
  const [bills, setBills] = useState([]);
  const [count, setCount] = useState('');
  const [sessionPontuada, setSessionPontuada] = useState(false);
  const [buttonPontuarText, setButtonPontuarText] =
    useState('Pontuar Clientes');

  const [modalClube, setModalClube] = useState(false);

  useEffect(() => {
    setSessionToUse(session);
  }, [session]);

  function toggleClube() {
    setModalClube(!modalClube);
  }

  const isBalconyPinpad = user.use_pinpad;
  const isDisableToReopen =
    isBalconyPinpad && session.table.table_type === 'balcony';

  const [paid, setPaid] = useState(0);
  const [porcent, setPorcent] = useState(0);
  const [printBills, setPrintBills] = useState([]);
  const [sessionBills, setSessionBills] = useState();
  const [productBills, setProductBills] = useState();
  const [commandTableNumber, setCommandTableNumber] = useState();
  const [isModalErrorUserPdvOpened, setIsModalUserPdvOpened] = useState(false);
  const [isSubmiting, setIsSubmiting] = useState(false);
  const { rescues, setRescues } = useClube();

  const toggleModalErrorUserPdv = useCallback(() => {
    setIsModalUserPdvOpened(!isModalErrorUserPdvOpened);
  }, [isModalErrorUserPdvOpened]);

  const [tables, setTables] = useState([]);
  const componentRef = useRef(null);
  function handleUpdateSession() {
    orderByTableDate();
    getMinimalSessions();
    getTablesAvailable();
  }

  const status = useMemo(() => {
    if (session.status === 'open') {
      return {
        statusText: 'Aberta',
        color: '#17a2b8',
      };
    }
    if (session.status === 'closing') {
      return {
        statusText: 'Fechando',
        color: '#17a2b8',
      };
    }
    if (session.status === 'finished') {
      return {
        statusText: 'Fechada',
        color: 'green',
      };
    }
    if (session.status === 'finished2') {
      return {
        statusText: 'Fechada',

        color: '#dc3545',
      };
    }
    return {
      statusText: '',
      color: '#ddd',
    };
  }, [session.status]);

  const [hasOpenedBox, setHasOpenedBox] = useState(false);
  const [modal, setModal] = useState(false);
  const [payments, setAllPayments] = useState(session?.payments);
  const [modalEye, setModalEye] = useState(false);

  const [modalEyeOpen, setModalEyeOpen] = useState(false);
  function toggleEyeOpen() {
    setModalEyeOpen(!modalEyeOpen);
  }

  const [modalReopen, setModalReopen] = useState(false);

  function toggleReopen() {
    setModalReopen(!modalReopen);
  }

  const [modalTransfer, setModalTransfer] = useState(false);
  async function toggleTransfer() {
    await getTables();
    setModalTransfer(!modalTransfer);
  }
  const [loadingBills, setLoadingBills] = useState(false);

  const getBillsSession = useCallback(async () => {
    setLoadingBills(true);
    const response = await api.get(
      `restaurants/table-sessions-bills/${session.id}`
    );

    setBills(response.data.bills);
    setPrintBills(response.data.print_bills);
    setSessionBills(response.data.session);
    setProductBills(response.data.products);

    const baskets = [];

    const sorted = baskets.sort((a, b) => {
      if (a.id < b.id) {
        return 1;
      }

      if (a.id > b.id) {
        return -1;
      }

      return 0;
    });

    setCommandTableNumber(sorted[0]);

    let sessionPontuada2 = true;
    response.data.bills.forEach((bill) => {
      if (!bill.rescued_clube) {
        sessionPontuada2 = false;
      }
    });
    setSessionPontuada(sessionPontuada2);
    if (sessionPontuada2) {
      setButtonPontuarText('Todos Clientes Já Pontuados!');
    }
    setLoadingBills(false);
  }, [session.id]);

  const iframeRef = useRef(null);
  const handleFetchDataToPrint = async (payload) => {
    try {
      const htmlResponse = await fetchDataToPrint(payload);
      printHtmlInIframe(iframeRef, htmlResponse);
    } catch (error) {
      toast.error('Erro ao buscar dados para impressão');
    }
  };

  async function handlePontuarBill({ session_key, bill_id }) {
    document.getElementById(bill_id).disabled = true;
    try {
      await api.post('public/clube/send/bill', {
        session_key,
        bill_id,
      });
      toast.success('Cliente pontuado!');
      getSessions();
      toggleClube();
    } catch (error) {
      toast.error('Não foi possível pontuar o cliente. Tente novamente');
      document.getElementById(bill_id).disabled = false;
    }
  }

  const getTables = useCallback(async (id) => {
    const response = await api.get('/restaurants/tables');
    const tablesData = response.data;

    const tablesFiltered = tablesData.filter(
      (table) => table.table_type === 'table' || table.table_type === 'command'
    );

    const tablesOptions = [];

    tablesFiltered.forEach((table) => {
      let status;
      if (table.status === 'available') {
        status = 'Disponível';
      } else {
        status = 'Em Uso';
      }

      tablesOptions.push({
        value: table.id,
        label: `${table.table_number.toString()} - ${status}`,
      });
    });

    setTables(tablesOptions);
  }, []);

  async function printClick() {
    try {
      await api.post('restaurants/printers/printer-queue', {
        table_session_id: session.id,
        close_after_print: true,
      });
      const newSessions = sessions?.filter((s) => s.id !== session.id);
      setSessions(newSessions);
      toast.success('Comanda impressa e fechada.');
    } catch (error) {
      toast.error('Erro ao imprimir e fechar comanda.');
    }
  }

  const payments_bill = session?.payments;

  const [paymentsBill, setPaymentsBill] = useState(payments_bill);

  async function handlePrintItem({ session_key }) {
    try {
      await api.put('restaurants/close-table-bill', {
        key: session_key,
      });
      getSessions();
      toast.success('Comanda fechada!');
    } catch (error) {
      toast.error('Não foi possível finalizar a comanda! tente novamente');
    }
  }

  async function handleSentMenew() {
    try {
      await api.post('restaurants/menew/send-bills', {
        session_key: session.key,
      });
      toast.success('Enviado para Menew!');
    } catch (error) {
      toast.error('Não foi possível enviar para Menew. Tente novamente');
    }
  }

  const getPayments = useCallback(async () => {
    let total = 0;

    paymentsBill.forEach((payment) => {
      total += parseFloat(payment.payment_value);
    });
    setPaid(total.toFixed(2).toString());

    const troco =
      total > sessionToUse?.total_service_price
        ? total - sessionToUse?.total_service_price
        : 0;

    const porcentPaid = sessionToUse?.is_delivery
      ? (total / sessionToUse?.total_delivery_price) * 100
      : ((total - troco) / sessionToUse?.total_service_price) * 100;
    setPorcent(parseFloat(porcentPaid.toFixed(2)));
  }, [paymentsBill, sessionToUse]);

  const toggleEye = useCallback(() => {
    setModalEye(!modalEye);
    getPayments();
  }, [setModalEye, modalEye, getPayments]);

  function toggle() {
    setModal(!modal);
    getPayments();
  }

  const [submittingReopen, setSubmittingReopen] = useState(false);

  const reopenTableBill = useCallback(async () => {
    try {
      setSubmittingReopen(true);
      await api.put('restaurants/reopen-table-bill', {
        key: session.key,
      });
      getSessions();
      setInputValueTables();
      setTablesFilteredSearch('');
      setSubmittingReopen(false);
      getTablesAvailable();
      setAllTablesAvailable('');

      toast.success('Comanda reaberta!');
    } catch (error) {
      setSubmittingReopen(false);
      if (session.table.status === 'ongoing') {
        toast.error('Essa mesa está aberta com outra sessão.');
      } else {
        toast.error('Erro ao reabrir mesa.');
        console.log(error);
      }
    }
  }, [
    session.key,
    session.table.status,
    getSessions,
    setInputValueTables,
    setTablesFilteredSearch,
    getTablesAvailable,
    setAllTablesAvailable,
  ]);

  const [isModalReopenOpened, setIsModalReopenOpened] = useState(false);
  const hasKey = user ? user.has_order_cancel_password : false;

  function handleVerifyReopenTableBill() {
    if (hasKey) {
      setIsModalReopenOpened(!isModalReopenOpened);
      setModalReopen(false);
    } else {
      reopenTableBill();
    }
  }

  async function handleTransferTableBill(data) {
    try {
      setIsSubmiting(true);
      await api.put('restaurants/transfer-table-bill', {
        key: session.key,
        table_id: data.new_table_id,
      });

      setTableChanged(data.new_table_id);
      toggleTransfer();
      getTablesAvailable();
      setIsSubmiting(false);
      toast.success('Mesa transferida com sucesso!');
    } catch (error) {
      toast.error('Erro ao transferir mesa.');
      setIsSubmiting(false);
    }
  }

  useEffect(() => {
    try {
      getPayments();
    } catch (error) {
      toast.error('Erro ao carregar informações');
    }
  }, [getPayments]);

  useEffect(() => {
    try {
      if (modalEye){
        getBillsSession();
      }
    } catch (error) {
      console.log(error);
    }
  }, [session, getBillsSession, modalEye]);

  const toggleModalHasOpenedBoxMessage = useCallback(() => {
    setHasOpenedBox(!hasOpenedBox);
  }, [hasOpenedBox]);

  function searchTableName(table) {
    if (table.table_type === 'balcony') {
      return 'Balcão';
    }

    if (table.table_type === 'pos') {
      return 'POS';
    }

    if (table?.table_type === 'self-service') {
      return 'Totem';
    }

    if (table.table_type === 'delivery') {
      return 'Delivery';
    }

    if (table.table_number === -10) {
      return 'Copa';
    }

    return `Mesa ${table.table_number}`;
  }

  const openingBoxRef = useRef();

  const verifyOpeningBox = useCallback(async () => {
    try {
      await api.get('/restaurants/cashier-opening-verify');

      toggleEye();
    } catch (err) {
      if (err?.response?.data?.errorType === 'cashier_opening_not_found') {
        toggleModalHasOpenedBoxMessage();
      } else {
        toast.error('Erro ao carregar valores totais');
      }
    }
  }, [toggleEye, toggleModalHasOpenedBoxMessage]);

  const [isModalOnlineDepositsOpened, setIsModalOnlineDepositsOpened] =
    useState(false);
  const [onlineDeposits, setOnlineDeposits] = useState([]);

  const toggleOnlineDepositisModal = useCallback(() => {
    setIsModalOnlineDepositsOpened(!isModalOnlineDepositsOpened);
  }, [isModalOnlineDepositsOpened]);
  const browserZoomLevel = Math.round(window.devicePixelRatio * 100);
  const openingBox = useCallback(
    async (data) => {
      if (!user?.is_pdv) {
        try {
          if (openingBoxRef?.current) {
            openingBoxRef.current.setErrors({});
          }

          const schema = Yup.object().shape({
            opening_value: Yup.string().required('Valor obrigatório'),
          });

          await schema.validate(data, {
            abortEarly: false,
          });

          const response = await api.post('/restaurants/cashier-opening', {
            initial_value: data.opening_value,
          });

          const { online_deposits } = response.data;
          setOnlineDeposits(online_deposits);

          if (online_deposits.length > 0) {
            toggleOnlineDepositisModal();
          }

          toggleModalHasOpenedBoxMessage();
          toggleEye();

          toast.success('Caixa aberto com sucesso.');
        } catch (error) {
          if (error instanceof Yup.ValidationError) {
            const errors = getValidationErrors(error);
            if (openingBoxRef?.current) {
              openingBoxRef.current.setErrors(errors);
            }
          } else if (error.response.data.errorType === 'cashier_already_open') {
            toast.error('Caixa já aberto');
          } else {
            toast.error('Erro ao abrir o caixa');
          }
        }
      } else {
        toggleModalErrorUserPdv();
      }
    },
    [
      toggleModalHasOpenedBoxMessage,
      toggleEye,
      user,
      toggleModalErrorUserPdv,
      toggleOnlineDepositisModal,
    ]
  );

  // restaurantes do Five nao podem nem reabrir e nem reativar comandas
  const isFiveSport = [
    29640, 36801, 36834, 29641, 35646, 28518, 35679,
  ].includes(user.id);

  const [inputPassword, setInputPassword] = useState('');

  const handleSubmitPassword = useCallback(() => {
    if (inputPassword === user.order_cancel_password) {
      reopenTableBill();
    } else {
      toast.error('Senha incorreta');
    }
  }, [inputPassword, user, reopenTableBill]);

  return (
    <>
      <ModalKit
        open={isModalReopenOpened}
        toggle={() => setIsModalReopenOpened(false)}
        style={{
          height: 'fit-content',
          width: 'fit-content',
          padding: 10,
        }}
      >
        <ModalKit.Body>
          <InputStyled
            placeholder="Digite a senha"
            label="Senha administrativa"
            onChange={(e) => setInputPassword(e.target.value)}
            type="password"
            autocomplete="new-password"
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: 10,
              gap: 10,
            }}
          >
            <ButtonKit
              onClick={() => setIsModalReopenOpened(false)}
              variant="outlined"
            >
              Cancelar
            </ButtonKit>
            <ButtonKit
              onClick={() => handleSubmitPassword()}
              disabled={submittingReopen}
            >
              Confirmar
            </ButtonKit>
          </div>
        </ModalKit.Body>
      </ModalKit>
      <CardContainer>
        <iframe ref={iframeRef} style={{ display: 'none' }} />
        <CardTop>
          <span style={{ fontSize: 16, fontWeight: 700 }}>
            {searchTableName(session.table)}
          </span>
          <span style={{ whiteSpace: 'nowrap' }}>
            {formatCompleteDate(session.end_time)}
          </span>
          <span>
            <div>
              #
              {session.table?.table_type === 'self-service' &&
              session.attendance_password
                ? session.attendance_password
                : session.id}
            </div>
            {session.table?.table_type === 'self-service' &&
              session.bills?.[0]?.buyer?.name && (
                <div style={{ fontSize: 12 }}>
                  {session.bills[0].buyer.name}
                </div>
              )}
          </span>
          <span>{formatValue(sessionToUse.total_service_price)}</span>
          <span>{formatValue(paid)}</span>
        </CardTop>
        <CardBottom>
          <PaymentPercentTag
            text={status.statusText}
            percent={
              sessionToUse.total_service_price === '0.00' ? '100' : porcent
            }
          />
          <Actions>
            {session?.status === 'finished' ||
            session?.status === 'completed' ? (
              <>
                <ActionsInside>
                  <DeleteAndEditActions>
                    {session?.status === 'completed' && user.has_menew && (
                      <CloseButton
                        onClick={() => handleSentMenew(session?.key)}
                        style={{ background: 'green' }}
                      >
                        <div style={{ fontSize: 10 }}>Enviar Menew</div>
                      </CloseButton>
                    )}
                    {user.is_printed_on_web || user.print_bills_on_web ? (
                      <div
                        onClick={() => {
                          handleFetchDataToPrint({
                            print_type: 'table_session',
                            table_session_id: session.id,
                          });
                        }}
                      >
                        <OrderButton
                          icon={<FaPrint />}
                          title="Imprimir"
                          color="#2EC9B7"
                          isLoading={loadingBills}
                        />
                      </div>
                    ) : (
                      <>
                        {session?.is_delivery ? (
                          <ReactToPrint
                            onBeforeGetContent={async () => {
                              await getBillsSession();
                            }}
                            trigger={() => (
                              <OrderButton
                                icon={<FaPrint />}
                                title="Imprimir"
                                color="#2EC9B7"
                                isLoading={loadingBills}
                              />
                            )}
                            content={() => componentRef.current}
                          />
                        ) : (
                          <OrderButton
                            icon={<FaPrint />}
                            title="Imprimir"
                            color="#2EC9B7"
                            isLoading={loadingBills}
                            onClick={printClick}
                          />
                        )}
                      </>
                    )}
                    {session?.status === 'finished' && (
                      <>
                        {!user?.is_pdv ? (
                          <OrderButton
                            icon={<FaCashRegister />}
                            title="Caixa"
                            color="#01AFFF"
                            onClick={verifyOpeningBox}
                          />
                        ) : (
                          <div />
                        )}

                        {session?.is_delivery ||
                        session?.is_prepaid ||
                        session.table.table_type === 'pos' ||
                        session.table.table_type === 'self-service' ? (
                          <div />
                        ) : (
                          <OrderButton
                            icon={<FaRedo />}
                            title="Reabrir"
                            color="#FFA814"
                            onClick={() => {
                              if (isDisableToReopen) {
                                toast.error(
                                  'Não foi possível reabrir o balcão.'
                                );
                                return;
                              }

                              toggleReopen();
                            }}
                            inverted={!isDisableToReopen}
                          />
                        )}
                      </>
                    )}
                  </DeleteAndEditActions>
                </ActionsInside>
              </>
            ) : (
              <div>
                <ActionsInside>
                  <DeleteAndEditActions>
                    <ReactToPrint
                      onBeforeGetContent={async () => {
                        await getBillsSession();
                      }}
                      trigger={() => (
                        <OrderButton
                          icon={<FaPrint />}
                          title="Fechar"
                          color="#2EC9B7"
                        />
                      )}
                      content={() => componentRef.current}
                      onAfterPrint={() =>
                        handlePrintItem({
                          session_key: session?.key,
                        })
                      }
                    />
                    {!user?.is_pdv ? (
                      <OrderButton
                        icon={<FaCashRegister />}
                        title="Caixa"
                        color="#01AFFF"
                        onClick={toggle}
                      />
                    ) : (
                      <div />
                    )}
                    <OrderButton
                      icon={<FaEye />}
                      color="#FFA814"
                      onClick={toggleEyeOpen}
                    />

                    {!session?.is_delivery && (
                      <OrderButton
                        icon={<BiTransfer />}
                        title="Mesa"
                        color="#FFA814"
                        onClick={toggleTransfer}
                      />
                    )}
                  </DeleteAndEditActions>
                </ActionsInside>
              </div>
            )}
          </Actions>
        </CardBottom>

        {has_nfce && session.status === 'completed' && (
          <th>
            {session.nfce_allowed ? (
              <AiOutlineCheckCircle size={23} color="green" />
            ) : (
              <AiOutlineCloseCircle size={23} color="red" />
            )}
          </th>
        )}
      </CardContainer>
      <Modal
        isOpen={isModalOnlineDepositsOpened}
        toggle={toggleOnlineDepositisModal}
      >
        <ModalBody>
          <strong>
            Os valores a seguir, que foram pagamentos online feitos enquanto seu
            caixa estava fechado, entrarão no caixa que você está abrindo:
          </strong>
          {onlineDeposits &&
            onlineDeposits.length > 0 &&
            onlineDeposits
              .filter((item) => item.total > 0)
              .map((deposit) => (
                <p>
                  {deposit.description} - R$ {deposit.total.toFixed(2)}
                </p>
              ))}
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-success"
            onClick={() => {
              toggleOnlineDepositisModal();
              setOnlineDeposits([]);
            }}
          >
            Ok, entendi
          </button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={hasOpenedBox} toggle={toggleModalHasOpenedBoxMessage}>
        <Form onSubmit={openingBox} ref={openingBoxRef}>
          <ModalBody>
            <FaExclamationCircle color="darkOrange" size={32} />
            <h3>Você precisa abrir seu caixa para inserir pagamentos.</h3>

            <Input
              name="opening_value"
              label="Valor inicial no caixa (Dinheiro)"
              type="number"
              step="0.01"
              min="0"
            />
          </ModalBody>
          <ModalFooter>
            <ButtonStyled
              operationType="withdrawal"
              type="button"
              onClick={toggleModalHasOpenedBoxMessage}
            >
              Cancelar
            </ButtonStyled>
            <ButtonStyled operationType="deposit" type="submit">
              Abrir caixa
            </ButtonStyled>
          </ModalFooter>
        </Form>
      </Modal>
      <Modal
        isOpen={isModalErrorUserPdvOpened}
        toggle={toggleModalErrorUserPdv}
      >
        <ModalBody>
          Seu perfil de usuário não possui permissão de abrir caixa. Solicite ao
          seu administrador
        </ModalBody>
        <ModalFooter>
          <div style={{ width: '100%' }}>
            <ButtonStyled
              operationType="deposit"
              type="button"
              onClick={toggleModalErrorUserPdv}
              style={{ float: 'right' }}
            >
              Entendi, irei solicitar.
            </ButtonStyled>
          </div>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalBody>
          <ModalPaymentBody>
            <PaymentForm
              session={session}
              getSessions={getMinimalSessions}
              payments_bill={paymentsBill}
              setPaymentsBill={setPaymentsBill}
              all_payments={payments}
              getPaymentsBill={getPayments}
              setAllPayments={setAllPayments}
              setCount={setCount}
              orderByTableDate={orderByTableDate}
              setRescues={setRescues}
              getBillsSession={getBillsSession}
              setSession={setSessionToUse}
            />
            <OrdersBillOperation />
          </ModalPaymentBody>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalEyeOpen} toggle={toggleEyeOpen}>
        <ModalBody>
          <EyeOrdersBillOperation
            session={session}
            inicialDate={inicialDate}
            finalDate={finalDate}
            setSessions={setSessions}
            toggleEyeOpen={toggleEyeOpen}
            orderByTableDate={orderByTableDate}
          />
        </ModalBody>
        <ModalFooter>
          <ReactToPrint
            onBeforeGetContent={async () => {
              await getBillsSession();
            }}
            trigger={() => (
              <CloseButton>
                <div style={{ fontSize: 15 }}>
                  <AiOutlinePrinter size={14} style={{ marginRight: 5 }} />
                  Imprimir
                </div>
              </CloseButton>
            )}
            content={() => componentRef.current}
          />
        </ModalFooter>
      </Modal>
      <ModalConfirmation
        isOpen={modalReopen}
        toggle={toggleReopen}
        title={
          session?.table?.status === 'available' ||
          session?.table?.table_type === 'balcony'
            ? 'Tem certeza que deseja reabrir essa comanda?'
            : 'Essa mesa está com uma sessão ativa no momento.'
        }
        confirm={() => handleVerifyReopenTableBill()}
        confirmDisabled={
          session?.table?.status !== 'available' &&
          session?.table?.table_type !== 'balcony'
        }
        cancel={toggleReopen}
      />

      {/* <Modal isOpen={modalReopen} toggle={toggleReopen}>
        <ModalBody>
          {session?.table?.status === 'available' ||
          session?.table?.table_type === 'balcony' ? (
            <p>Tem certeza que deseja reabrir essa comanda?</p>
          ) : (
            <p style={{ color: 'red' }}>
              Essa mesa está com uma sessão ativa no momento.
            </p>
          )}
        </ModalBody>
        <ModalFooter>
          {(session?.table?.status === 'available' ||
            session?.table?.table_type === 'balcony') && (
            <Button
              onClick={handleReopenTableBill}
              style={{ background: 'green' }}
            >
              Sim, reabrir
            </Button>
          )}
          <Button onClick={toggleReopen} style={{ background: '#dc3545' }}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal> */}

      <Modal isOpen={modalTransfer} toggle={toggleTransfer}>
        <Form onSubmit={handleTransferTableBill}>
          <ModalBody style={{ padding: 20 }}>
            <h3 style={{ fontSize: 20, fontWeight: 700, marginBottom: 10 }}>
              Transferência de Mesa
            </h3>
            {tables.length !== 0 ? (
              <div>
                <h6 style={{ fontSize: 16 }}>
                  Mesa atual: <strong>{session?.table?.table_number}</strong>
                </h6>
                <SelectTable
                  name="new_table_id"
                  label="Nova mesa:"
                  options={tables.filter((a) => a.value !== session?.table?.id)}
                />
              </div>
            ) : (
              <p style={{ color: 'red' }}>
                Não há nenhuma mesa disponível no momento.
              </p>
            )}
          </ModalBody>
          <ModalFooter style={{ padding: '0 20px 20px' }}>
            <Button
              onClick={(e) => {
                e.preventDefault();
                toggleTransfer();
              }}
              title="Cancelar"
            />
            {tables.length !== 0 && (
              <Button
                type="submit"
                title="Transferir"
                onClick={() => {}}
                buttonColor="#2EC9B7"
                disabled={isSubmiting}
              />
            )}
          </ModalFooter>
        </Form>
      </Modal>

      <DisplayNoneImprimir>
        <PrintBillsOrderOperation
          item={session}
          restaurant={user}
          ref={componentRef}
          count={count}
          paymentData={payments}
          printBills={printBills}
          sessionBills={sessionBills}
          productBills={productBills}
          commandTableNumber={commandTableNumber}
        />
      </DisplayNoneImprimir>

      <Modal isOpen={modalEye} toggle={toggleEye} size="lg">
        <InnerArea browserZoomLevel={browserZoomLevel}>
          <ModalPaymentBody>
            <PaymentForm
              session={sessionToUse}
              setSession={setSessionToUse}
              payments_bill={paymentsBill}
              setPaymentsBill={setPaymentsBill}
              all_payments={payments}
              getPaymentsBill={getPayments}
              setAllPayments={setAllPayments}
              setCount={setCount}
              getSessions={getMinimalSessions}
              setRescues={setRescues}
              getBillsSession={getBillsSession}
            />
            <EyeBillsTableOperation
              item={sessionToUse}
              setItem={setSessionToUse}
              payments_bill={payments_bill}
              bills={bills}
              count={count}
            />
          </ModalPaymentBody>
          <Row style={{ marginTop: 10 }}>
            <Col md="6" />
            {user.has_clube && (
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  buttonColor="#2ec9b7"
                  title={buttonPontuarText}
                  disabled={sessionPontuada}
                  icon={<TiTicket />}
                  onClick={toggleClube}
                />
              </div>
            )}
          </Row>

          {session?.status === 'finished' && (
            <FooterNF
              session={session}
              toggleEye={toggleEye}
              getSessions={handleUpdateSession}
              payments={payments}
              has_nfce={user.has_nfce}
              rescues={rescues}
              setRescues={setRescues}
            />
          )}
        </InnerArea>
      </Modal>
      <Modal isOpen={modalClube} toggle={toggleClube}>
        <ModalBody>
          <Row>
            <Col>
              <h3>Pontuar no Clube</h3>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              {porcent < 100 && (
                <p>
                  Deseja pontuar apenas R${paid} do valor consumido aos
                  clientes?
                </p>
              )}
            </Col>
          </Row>
          <Row style={{ marginBottom: 15 }}>
            <Col md="6">
              {!sessionPontuada && (
                <Button
                  title="Pontuar todos"
                  id={`s${session?.key}`}
                  buttonColor="#2ec9b7"
                  onClick={() => {
                    if (!sessionsAwarded.includes(session?.id)) {
                      handlePontuarSession({ session_key: session?.key });
                    } else {
                      toast.error('Sessão já pontuada!');
                    }
                  }}
                  disabled={loadingPontuarSession}
                />
              )}
            </Col>
          </Row>
          {bills &&
            bills.length > 0 &&
            bills.map(
              (bill) =>
                bill.buyer && (
                  <Row style={{ marginBottom: 14 }}>
                    <Col md="8">
                      <h5>{bill.buyer.phone || bill.buyer.name}</h5>
                    </Col>
                    <Col md="4">
                      {bill.rescued_clube || sessionPontuada ? (
                        <p style={{ textAlign: 'right', marginTop: 4 }}>
                          Pontuado!
                        </p>
                      ) : (
                        <Button
                          id={bill.id}
                          title="Pontuar"
                          style={{
                            float: 'right',
                            background: '#02CA91',
                            border: 'none',
                          }}
                          onClick={() => {
                            if (!sessionsAwarded.includes(session?.id)) {
                              handlePontuarBill({
                                session_key: session?.key,
                                bill_id: bill.id,
                              });
                            } else {
                              toast.error('Sessão já pontuada!');
                            }
                          }}
                        />
                      )}
                    </Col>
                  </Row>
                )
            )}
        </ModalBody>
        <ModalFooter>
          <Button onClick={toggleClube} title="Fechar" />
        </ModalFooter>
      </Modal>
    </>
  );
}
